import React, {useCallback} from 'react'
import ListItem, {BaseProps} from './ListItem'
import {ColInfo, ColPhoto, ColStat} from '../Col'
import styles from '../../../../CSS/main.css'
import classNames from 'classnames'
import {useNavigation} from '../../../utils/navigation'
import {WebsiteItem as WebsiteItemType} from "../../../../../types";
import {Routes} from "../../../routing";

export type FilterWords = {
    id: string,
    forbiddenWord: string
}

export enum WebsiteStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum WebsiteCommentsStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export type Props = {
  readonly filterWords: FilterWords
} & BaseProps

const FilterWordsItem: React.VFC<Props> = ({
  onSelected,
  selected,
  options,
  filterWords,
}) => {
  const { goTo } = useNavigation()

//   const navigateToSite = useCallback(() => {
//     goTo(Routes.EditWebsite, { id: encodeURIComponent(website.name) })
//   }, [])

  return (
    <ListItem
      onClick={null}
      onSelected={onSelected}
      selected={selected}
      options={options}>
      <ColInfo>
        <p className={classNames([styles.InfoBig, styles.Ellipsis])}>
          {filterWords.forbiddenWord}
        </p>
      </ColInfo>
    </ListItem>
  )
}

export default FilterWordsItem
